export enum ProlongationStatus {
  WaitingSigning = 1,
  WaitingPayment,
  Waiting,
  Active,
  Complete
}
